import { useSuspenseQuery } from '@tanstack/react-query';

import { signalListQueryOptions } from '@/entities/signal';

export const useSignalSelectOptions = ({
  workspaceId,
}: {
  workspaceId: string;
}) => {
  const { data: signals = [] } = useSuspenseQuery(
    signalListQueryOptions({ workspaceId }),
  );

  const options = signals.map((signal) => ({
    value: signal.id,
    label: signal.title,
  }));

  return { options };
};
